import { Controller } from '@hotwired/stimulus';

export default class BlocklistController extends Controller {
  connect() {
    this.unblocked = false;
    this.handleModalHidden = this.handleModalHidden.bind(this);
    document.addEventListener('hidden.bs.modal', this.handleModalHidden);
  }

  disconnect() {
    document.removeEventListener('hidden.bs.modal', this.handleModalHidden);
  }

  markUnblocked() {
    this.unblocked = true;
  }

  handleModalHidden() {
    if (!this.unblocked) return;

    this.unblocked = false;
    if (globalThis.location.pathname === '/posts') {
      globalThis.location.reload();
    }
  }
}
